
window.formatDate = function(date,format,withTime){
	if(withTime === null){
		withTime = true;
	}
    let now  = moment();
	if(typeof date != "object"){
		date = moment(date);
	}
	if(!format){

		format = window.translate('momentDateFormat.fullDay');
		if(withTime){
			format = window.translate('momentDateFormat.fullDayTime');
		}

	    if(now.format('DDMMYYYY') == date.format('DDMMYYYY')){
	    	//same day
			format = window.translate('momentDateFormat.time');
	    }else if(now.format('MMYYYY') == date.format('MMYYYY')){
	    	//same month
	    	format = window.translate('momentDateFormat.monthDay');
			if(withTime){
				format = window.translate('momentDateFormat.monthDayTime');
			}
	    }else if(now.format('YYYY') == date.format('YYYY')){
	    	//same yearformat = window.translate('momentDateFormat.fullDay');
	    	format = window.translate('momentDateFormat.monthDay');
			if(withTime){
				format = window.translate('momentDateFormat.monthDayTime');
			}
    	}
    }
    return date.format(format);
}

window.ensureFloatText = function(value){
	if(typeof value == 'string'){
		value = value.replace(',','.');
	}
	return value;
}

window.formatFloat = function(value,decimals,separator){
	if(!decimals){
		decimals = 2;
	}
	if(!separator){
		separator = ',';
	}
	if(value === null){
		value = 0;
	}
	value = window.ensureFloatText(value);
	value =  parseFloat(value);
	if(isNaN(value)){
		value = 0;
	}
	if(separator == ','){
		return value.toLocaleString('fr',{'maximumFractionDigits': decimals,'minimumFractionDigits': decimals});
	}

	value =  value.toFixed(decimals);
	//let zeros = '';
	//for(var i=0;i<decimals;i++){
	//	zeros+='0';
	//}
	//value = value.replace('.'+zeros,'');
	return value.replace('.',separator);
}

window.translate = function(key,data,domain){
	return window.App.translate(key,data,domain);
}

window.stringifyObject = function(param){
    if(Array.isArray(param)){ // In case of an array, recursively call our function on each element.
        let results = [];
        for(let elem of param){
            results.push(stringifyObject(elem));
        }
        return "[" + results.join(",") + "]";
    }
    else if(typeof param === "object"){ // In case of an object, loop over its keys and only add quotes around keys that aren't valid JavaScript variable names. Recursively call our function on each value.
        let props = Object
            .keys(param)
            .map(function(key){
                // A valid JavaScript variable name starts with a dollar sign (?), underscore (_) or letter (a-zA-Z), followed by zero or more dollar signs, underscores or alphanumeric (a-zA-Z\d) characters.
                if(key.match(/^[a-zA-Z_$][a-zA-Z\d_$]*$/) === null) // If the key isn't a valid JavaScript variable name, we need to add quotes.
                    return `"${key}":${stringifyObject(param[key])}`;
                else
                    return `${key}:${stringifyObject(param[key])}`;
            })
            .join(",");
        return `{${props}}`;
    }
    else{ // For every other value, simply use the native JSON.stringify() function.
        return JSON.stringify(param);
    }
}

window.refresh = function(millisecondsToWait){
	if(millisecondsToWait === null) millisecondsToWait = 'now';

	if(millisecondsToWait && Number.isInteger(millisecondsToWait) && millisecondsToWait > 0){
		setTimeout(
			function(){ 
				window.refresh('now');
			},
			millisecondsToWait
		);
	}else{
		window.location.reload();
	}
}

window.redirect = function(url,millisecondsToWait){
	if(millisecondsToWait === null) millisecondsToWait = 'now';

	if(millisecondsToWait && Number.isInteger(millisecondsToWait) && millisecondsToWait > 0){
		setTimeout(
			function(){ 
				window.redirect(url,'now');
			},
			millisecondsToWait
		);
	}else{
		window.location.href = url;
	}
}

window.uniqid = function(separator='-'){
	function chr4(){
		return Math.random().toString(16).slice(-4);
	}

	var id = 'uniqid' + chr4() + chr4() +
	separator + chr4() +
	separator + chr4() +
	separator + chr4() +
	separator + chr4() + chr4() + chr4();
	
	if($('#'+id).length > 0){
		return window.uniqid();
	}
	return id;
}

window.replaceTagName = function($source,newTag){
	var $newElement = $('<'+newTag+'/>');

	//content
	var content = $source.html();
	$newElement.append(content);


	//attributes
	var sourceAttributes = $source[0].attributes;
	var attributes = [
		'id','name','class','style','data-.*'
	];

	for(var i in attributes){
		var attr = attributes[i];
		var regex = new RegExp('^'+attr+'$');
		for(var j in sourceAttributes){

			var sourceAttr = sourceAttributes[j];

			if(regex.test(sourceAttr.name)){
				$newElement.attr(sourceAttr.name,sourceAttr.value);
			}
		}
	}

	//events
	var events = $source[0].events;	
    $.each(events, function(eventType, eventArray) {
        $.each(eventArray, function(index, event) {
			var eventToBind = event.namespace.length > 0 ? (event.type + '.' + event.namespace) : (event.type);
			$newElement.bind(eventToBind, event.data, event.handler);
        })
    });

	return $newElement;
}

window.uncacheFile = function(path,callback){
	if(callback === null){
		callback = function(){};
	}

	var headers = new Headers()
	headers.append('pragma', 'no-cache')
	headers.append('cache-control', 'no-cache')
	var init = {
		method: 'GET',
		headers: headers,
		mode: 'no-cors',
		cache: 'no-cache',
	}
	fetch(new Request(path), init)
	.then(callback);

}

window.notify = function(message,level,data,delay){
	if( window.App){
		return window.App.notify(message,level,data,delay);
	}
	switch(level){
		case 'error':
		case 'danger':
			console.error(message,data);
		break;
		default:
			console.log(message,data);
		break;
	}
}

window.isHtml = function(str) {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}

window.isUrl = function(str){
	try { return Boolean(new URL(str)); }
	catch(e){ return false; }	
}

window.isNumeric = function(value) {
    return /^-?\d+$/.test(value);
}

window.basename = function(path){
	let separator = '/';
	const windowsSeparator = '\\';
	if (path.includes(windowsSeparator)) {
		separator = windowsSeparator;
	}
	return path.slice(path.lastIndexOf(separator) + 1)
}

window.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

window.isString = function(variable){
	if (typeof variable === 'string' || variable instanceof String){
		return true;
	}
	return false;
}

window.ellipseText = function(text, max){
	if(!window.isString(text)){
		return text;
	}
	if(!max){
		max = 100;
	}
	if(text.length <= max){
		return text;
	}
    return text.substr(0,max-1)+(text.length>max?'&hellip;':''); 
}

window.getSessionValue = function(key){
	return sessionStorage.getItem(key);
}

window.setSessionValue = function(key,value){
	return sessionStorage.setItem(key, value);
}


//todo improve to get multilevel array
window.getAllUrlParams = function () {
	var parameters = {};

    var params = window.location.search.substring(1).split('&');

    let paramIsArrayRegex = /(\[\])$/;
    for (var i = params.length - 1; i >= 0; i--) {
    	let param = params[i];
    	let paramAsArray = param.split('=');

    	let key = paramAsArray[0];
    	let value = paramAsArray[1];
    	if(key){

	    	if(key.match(paramIsArrayRegex)){
	    		let arrayKey = key.replace(paramIsArrayRegex,'');
	    		if(!parameters[arrayKey]){
	    			parameters[arrayKey] = [];
	    		}
	    		parameters[arrayKey].push(value);
	    	}else{
	    		parameters[key] = value;	
	    	}
	    }
    };
    return parameters;
}

//todo improve to get multilevel array
window.objectToUrlParameters = function(object){

	let keys = Object.keys(object);
	let params = [];
	for(var i in keys){
		let key = keys[i];
		let value = object[key];
		if(Array.isArray(value)){
			for(var i in value){
				let innerValue = value[i];
				params.push(key+'[]='+innerValue);
			}
		}else{
			params.push(key+'='+value);
		}
	}
	return params.join("&");
}

window.setUrlParameter = function(key,value){
	let parameters = window.getAllUrlParams();

	parameters[key] = value;
	let search = window.objectToUrlParameters(parameters);

	window.history.replaceState(null,null,window.location.pathname+'?'+search)
}

window.serializeForm = function($form){
	let form = $form[0];
	let data = Object.fromEntries(new FormData(form));
	return data;
}

window.buildFormData = function(formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      window.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }
}

window.jsonToFormData = function(data) {
  const formData = new FormData();
  
  buildFormData(formData, data);
  
  return formData;
}

window.select2 = function($select,options){
	if(options == null){
		options = {};
	}
	let $parent = $select.parent();
	options['dropdownParent'] = $parent;
	options['theme'] = "bootstrap-5";
	options['language'] = $('html').attr('lang');
	$select.select2(options);
}

window.htmldecode = function(s){
    window.HTML_ESC_MAP = {
    "nbsp":" ","iexcl":"¡","cent":"¢","pound":"£","curren":"¤","yen":"¥","brvbar":"¦","sect":"§","uml":"¨","copy":"©","ordf":"ª","laquo":"«","not":"¬","reg":"®","macr":"¯","deg":"°","plusmn":"±","sup2":"²","sup3":"³","acute":"´","micro":"µ","para":"¶","middot":"·","cedil":"¸","sup1":"¹","ordm":"º","raquo":"»","frac14":"¼","frac12":"½","frac34":"¾","iquest":"¿","Agrave":"À","Aacute":"Á","Acirc":"Â","Atilde":"Ã","Auml":"Ä","Aring":"Å","AElig":"Æ","Ccedil":"Ç","Egrave":"È","Eacute":"É","Ecirc":"Ê","Euml":"Ë","Igrave":"Ì","Iacute":"Í","Icirc":"Î","Iuml":"Ï","ETH":"Ð","Ntilde":"Ñ","Ograve":"Ò","Oacute":"Ó","Ocirc":"Ô","Otilde":"Õ","Ouml":"Ö","times":"×","Oslash":"Ø","Ugrave":"Ù","Uacute":"Ú","Ucirc":"Û","Uuml":"Ü","Yacute":"Ý","THORN":"Þ","szlig":"ß","agrave":"à","aacute":"á","acirc":"â","atilde":"ã","auml":"ä","aring":"å","aelig":"æ","ccedil":"ç","egrave":"è","eacute":"é","ecirc":"ê","euml":"ë","igrave":"ì","iacute":"í","icirc":"î","iuml":"ï","eth":"ð","ntilde":"ñ","ograve":"ò","oacute":"ó","ocirc":"ô","otilde":"õ","ouml":"ö","divide":"÷","oslash":"ø","ugrave":"ù","uacute":"ú","ucirc":"û","uuml":"ü","yacute":"ý","thorn":"þ","yuml":"ÿ","fnof":"ƒ","Alpha":"Α","Beta":"Β","Gamma":"Γ","Delta":"Δ","Epsilon":"Ε","Zeta":"Ζ","Eta":"Η","Theta":"Θ","Iota":"Ι","Kappa":"Κ","Lambda":"Λ","Mu":"Μ","Nu":"Ν","Xi":"Ξ","Omicron":"Ο","Pi":"Π","Rho":"Ρ","Sigma":"Σ","Tau":"Τ","Upsilon":"Υ","Phi":"Φ","Chi":"Χ","Psi":"Ψ","Omega":"Ω","alpha":"α","beta":"β","gamma":"γ","delta":"δ","epsilon":"ε","zeta":"ζ","eta":"η","theta":"θ","iota":"ι","kappa":"κ","lambda":"λ","mu":"μ","nu":"ν","xi":"ξ","omicron":"ο","pi":"π","rho":"ρ","sigmaf":"ς","sigma":"σ","tau":"τ","upsilon":"υ","phi":"φ","chi":"χ","psi":"ψ","omega":"ω","thetasym":"ϑ","upsih":"ϒ","piv":"ϖ","bull":"•","hellip":"…","prime":"′","Prime":"″","oline":"‾","frasl":"⁄","weierp":"℘","image":"ℑ","real":"ℜ","trade":"™","alefsym":"ℵ","larr":"←","uarr":"↑","rarr":"→","darr":"↓","harr":"↔","crarr":"↵","lArr":"⇐","uArr":"⇑","rArr":"⇒","dArr":"⇓","hArr":"⇔","forall":"∀","part":"∂","exist":"∃","empty":"∅","nabla":"∇","isin":"∈","notin":"∉","ni":"∋","prod":"∏","sum":"∑","minus":"−","lowast":"∗","radic":"√","prop":"∝","infin":"∞","ang":"∠","and":"∧","or":"∨","cap":"∩","cup":"∪","int":"∫","there4":"∴","sim":"∼","cong":"≅","asymp":"≈","ne":"≠","equiv":"≡","le":"≤","ge":"≥","sub":"⊂","sup":"⊃","nsub":"⊄","sube":"⊆","supe":"⊇","oplus":"⊕","otimes":"⊗","perp":"⊥","sdot":"⋅","lceil":"⌈","rceil":"⌉","lfloor":"⌊","rfloor":"⌋","lang":"〈","rang":"〉","loz":"◊","spades":"♠","clubs":"♣","hearts":"♥","diams":"♦","\"":"quot","amp":"&","lt":"<","gt":">","OElig":"Œ","oelig":"œ","Scaron":"Š","scaron":"š","Yuml":"Ÿ","circ":"ˆ","tilde":"˜","ndash":"–","mdash":"—","lsquo":"‘","rsquo":"’","sbquo":"‚","ldquo":"“","rdquo":"”","bdquo":"„","dagger":"†","Dagger":"‡","permil":"‰","lsaquo":"‹","rsaquo":"›","euro":"€"};
    if(!window.HTML_ESC_MAP_EXP)
        window.HTML_ESC_MAP_EXP = new RegExp("&("+Object.keys(HTML_ESC_MAP).join("|")+");","g");
    return s?s.replace(window.HTML_ESC_MAP_EXP,function(x){
        return HTML_ESC_MAP[x.substring(1,x.length-1)]||x;
    }):s;
}

window.sortArrayOfObjectByProperty = function(array,p){
	return array.sort(function(a,b) {
    	return (a[p] > b[p]) ? 1 : (a[p] < b[p]) ? -1 : 0;
  	});
}


window.computeXYDataToGraphData = function(xyData,xWriter,yWriter){

	let labels = [];
	let data = [];

	for(var i in xyData){
		let item = xyData[i];

		let label = item.x;
		if(xWriter){
			label = xWriter(label);
		}
		let value = item.y;
		if(yWriter){
			value = yWriter(value);
		}
		labels.push(label);
		data.push(value);
	}

	return {
		'labels': labels,
		'data': data,
	};
}


window.bindAutocomplete = function($input,callback,typingInterval){

	let timerCallback = function(){
		if(!typingInterval){
			typingInterval = 500;
		}
		let inputAutocompleteId = $input.data('autocomplete-id');
		if(!inputAutocompleteId){
			inputAutocompleteId = window.uniqid();
			$input.data('autocomplete-id',inputAutocompleteId);
		}

		if(!window.autocompleteTimers){
			window.autocompleteTimers = {};
		}

		if(window.autocompleteTimers[inputAutocompleteId]){
			clearTimeout(window.autocompleteTimers[inputAutocompleteId]);
		}

		window.autocompleteTimers[inputAutocompleteId] = setTimeout(callback,typingInterval);
	};


	$input.on('keydown',timerCallback)
	$input.on('keyup',timerCallback);
}


window.appCache = {};
window.getFromCache = function(identifier){
	if(identifier in window.appCache){
		return window.appCache[identifier];
	}
	return null;
}
window.addToCache = function(identifier,data){
	window.appCache[identifier] = data;
	return true;
}

window.downloadFile = function(url,fileName){
	var link = document.createElement('a');
	link.href = url;
	link.target = '_blank';
	if(fileName){
		link.download = fileName;
	}
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}